import { useMemo } from 'react'
import { ChartOptions } from 'chart.js'
import styles from 'components/charts/Charts.module.scss'
import { Chart } from 'react-chartjs-2'
import { PriceHistoryChartProps } from './types.ts'
import { getPriceHistoryChartOptions } from './chartjs.config.ts'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'

const PriceHistoryChartMobile = ({ chartData, granularity, isFetching, labels, setHoverDataPointIndex }: PriceHistoryChartProps) => {
  const options = useMemo<ChartOptions<'bar'>>(
    () => getPriceHistoryChartOptions({ labels, granularity, handleHoverDataPoint: setHoverDataPointIndex, isMobile: true }),
    [labels, granularity, setHoverDataPointIndex]
  )

  return !isFetching ? (
    <div className={styles['chart-wrapper']}>
      <Chart type="bar" options={options} data={chartData} className={styles.chart} />
    </div>
  ) : (
    <LoadingSkeleton>
      <LoadingSkeleton.Rectangle aspectRatio="2.5 / 1" />
    </LoadingSkeleton>
  )
}

export default PriceHistoryChartMobile
